import React, { useEffect, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getDealerships, getFirms } from 'app/api';
import SelectBox from 'app/components/common/SelectBox/SelectBox';
import JoinFirmList from 'app/components/join/JoinFirmList';
import AlignBox from 'app/components/common/AlignBox';
import Button from 'app/components/common/Button';
import LoadingBar from 'app/components/common/LoadingBar';

function JoinFirmSelectContainer({ associationCode, onSubmit }) {
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [dealerships, setDealerships] = useState([]);
	const [dealershipCode, setDealershipCode] = useState('');
	const [firms, setFirms] = useState(null);
	const [firmCode, setFirmCode] = useState('');

	const initDealerships = useCallback(async () => {
		try {
			const { data } = await getDealerships(associationCode);
			setDealerships(data);
		} catch (e) {
			console.error(e);
			alert('단지 정보를 불러오지 못했습니다.');
		}
	}, [associationCode]);

	useEffect(() => {
		if (associationCode) {
			initDealerships();
		} else {
			history.goBack();
		}
	}, [associationCode, initDealerships, history]);

	const initFirms = useCallback(
		async (character) => {
			if (associationCode && dealershipCode) {
				try {
					setLoading(true);
					const { data } = await getFirms(associationCode, dealershipCode, character);
					setFirms(data);
				} catch (e) {
					console.error(e);
					alert('상사 정보를 불러오지 못했습니다.');
				} finally {
					setLoading(false);
				}
			}
		},
		[associationCode, dealershipCode],
	);

	useEffect(() => {
		initFirms();
	}, [initFirms]);

	const handleDealership = useCallback((e) => {
		setDealershipCode(e.target.value);
	}, []);

	const handleFirmTab = (_, character) => {
		initFirms(character === '전체' ? undefined : character);
		setFirmCode('');
	};

	const handleFirmChange = (e) => {
		setFirmCode(e.target.value);
	};

	const handleSubmit = () => {
		if (!firms || !firmCode) {
			alert('상사를 선택해주세요.');
			return;
		}
		const selectedFirm = firms.find((firm) => firm.code === firmCode);
		onSubmit(selectedFirm);
	};

	return (
		<>
			<SelectBox
				useLabelBlind
				name="complexName"
				id="complexName"
				data={[
					{
						key: 'default',
						name: '매매단지 선택',
						value: '',
					},
					...dealerships.map((item) => ({
						key: item.code,
						name: item.name,
						value: item.code,
					})),
				]}
				value={dealershipCode}
				onChange={handleDealership}
				style={{ marginTop: '20px' }}
			/>

			{!firms && (
				<p
					className="fs14 fcBlack3 taCenter"
					style={{ marginTop: '50px' }}
				>
					매매상사가 소속된 단지명을 먼저 선택해주세요.
				</p>
			)}
			{firms && (
				<JoinFirmList
					dataList={firms.map((item) => ({ name: item.name, value: item.code }))}
					value={firmCode}
					onChangeTab={handleFirmTab}
					onChangeFirm={handleFirmChange}
				/>
			)}

			<AlignBox
				type="float"
				col="1"
				fixed
			>
				<Button
					key="확인"
					color="red"
					size="45"
					domType="button"
					title="확인"
					onClick={handleSubmit}
				/>
			</AlignBox>

			{loading && <LoadingBar />}
		</>
	);
}

export default JoinFirmSelectContainer;
